export default {"src":"/_next/static/media/Menu.8ad608b9.svg","height":18,"width":24};